import React from "react";
import Card from "../Card";
import { ShortTermTrading } from "../../constants";


import { SiMarketo } from "react-icons/si";
const ShortTerm = () => {
    return (
        <div className=" font-lato pt-16">
           
          
          <div className="flex flex-wrap justify-center gap-12">
            
            {ShortTermTrading.slice(0, 8).map((plan, index) => (
              
             <Card
             title="Short Term Plan"
             investment={plan.investment}
             profit={plan.profit}
             rewardIcon={<SiMarketo />} // replace with an actual SVG or icon component
             index={index}
             time="1 Month"
           />
            ))}
          </div>
        </div>
      );
}

export default ShortTerm;